import { useState, useEffect } from 'react';
import { useGetAddressesListQuery } from '@/store/services/address';
import AddressesHeader from './AddressesHeader';
import AddressesTable from './AddressesTable';
import AddressForm from './AddressForm';

type Address = {
	id: number;
	user_id: number;
	name: string | null;
	location_name: string | null;
	type: string | null;
	user: {
		id: number;
		name: string;
		email: string;
	} | null;
	documents: unknown[];
	application: unknown | null;
};

function Addresses() {
	const [editingAddress, setEditingAddress] = useState<Address | null>(null);
	const { refetch: refetchAddresses } = useGetAddressesListQuery({});

	// Always hit `/api/address` when this page is shown (not only from RTK cache).
	useEffect(() => {
		void refetchAddresses();
	}, [refetchAddresses]);

	const handleEdit = (address: Address) => {
		setEditingAddress(address);
	};

	const handleFormReset = () => {
		setEditingAddress(null);
	};

	return (
		<div className="flex flex-col min-w-0 flex-auto">
			<div className="flex-1">
				<div className="max-w-6xl mx-auto space-y-6">
					<div className="w-full h-full flex flex-col px-4">
						<AddressesHeader />
						<AddressForm
							editingAddress={editingAddress}
							onReset={handleFormReset}
						/>
						<AddressesTable onEdit={handleEdit} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Addresses;
